import { StyledButton } from './Button';

export const LinkButton = StyledButton.withComponent('a');
